module.exports = __webpack_public_path__ + "media/ss_photos/ss-overview-photo-06-3bf762f0.webp";